import React, {useState, useEffect, Fragment} from 'react'
import {Table, Popup, Icon, Loader, Button} from 'semantic-ui-react'
import {useFirestore} from 'react-redux-firebase';
import {useDispatch} from 'react-redux';
import {Channelselect} from '../channelselect';
import {EventlistByDate} from './eventlist_by_date';
import {EventDetails} from './eventdetails';
import {env} from '../../../constants/Environment';
import * as RouterActions from '../../../actions/RouterActions';
import {CanvasNavigation} from '../Navigation'
import {Dateselect} from './dateselect';

export default function Eventlist(props){
    const firestore = useFirestore();
    const dispatch = useDispatch();

    const [activeItem, setActiveItem] = useState(0);

    const modeToName = {
        'bydate': 'nach Datum'
    };

/*useEffect(() => {
        if(typeof props.match.params.channel !== 'undefined' && props.match.params.channel.length > 0){
            (async () => {
                await firestore.collection('environments/' + env + '/canvas/' + props.match.params.channel)
            })()
        }
    }, [props.match.params.channel]);*/

    return (
        <CanvasNavigation breadcrumb={[
            {
                'caption': 'Events',
                'href': 'canvas/events'
            },
            ...(typeof props.match.params.channel !== 'undefined' && props.match.params.channel.length > 0)?[{            
                'caption': props.match.params.channel,
                'href': 'canvas/events/' + props.match.params.channel
            }]:[],
            ...(typeof props.match.params.mode !== 'undefined')?[{            
                'caption': modeToName[props.match.params.mode],
                'href': 'canvas/events/' + props.match.params.channel + '/' + props.match.params.mode
            }]:[],
            ...(typeof props.match.params.date !== 'undefined')?[{            
                'caption': props.match.params.date.split('-').reverse().join('.'),
                'href': 'canvas/events/' + props.match.params.channel + '/' + props.match.params.mode + '/' + props.match.params.date
            }]:[],
            ...(typeof props.match.params.channel !== 'undefined' && props.match.params.channel.length > 0 && typeof props.match.params.eventid !== 'undefined')?[{            
                'caption': props.match.params.eventid,
                'href': 'canvas/events/' + props.match.params.channel + '/' + props.match.params.mode + '/' + props.match.params.eventid
            }]:[]
        ]}>
            <div>
                {
                    (typeof props.match.params.channel !== 'undefined' && props.match.params.channel.length > 0)?null
                    :<Channelselect onChannelSelect={(channelId) => {
                        dispatch(RouterActions.push('canvas/events/' + channelId + '/bydate'));
                    }} />
                }
                {
                    (typeof props.match.params.channel !== 'undefined' && props.match.params.channel.length > 0 && typeof props.match.params.mode !== 'undefined')?
                        (props.match.params.mode === 'bydate' && typeof props.match.params.eventid === 'undefined')?
                            <Fragment>
                                <Dateselect date={props.match.params.date} onDateChange={(date) => {
                                    dispatch(RouterActions.push('canvas/events/' + props.match.params.channel + '/bydate/' + date));
                                }} />
                                <EventlistByDate channel={props.match.params.channel} date={props.match.params.date} onEventClick={(event) => {
                                    dispatch(RouterActions.push('canvas/events/' + props.match.params.channel + '/bydate/' + ((typeof props.match.params.date !== 'undefined')?props.match.params.date:'today') + '/' + event.uid));
                                }} />
                            </Fragment>
                        :null
                    :null
                }
                {
                    (typeof props.match.params.channel !== 'undefined' && props.match.params.channel.length > 0 && typeof props.match.params.eventid !== 'undefined')?
                        <EventDetails channel={props.match.params.channel} id={props.match.params.eventid} />
                    :null
                }

            </div>
        </CanvasNavigation>
    );

    /*const event = useSelector((state) => {
        let selectedTournament = state.structure.getIn(['selected', 'tournament']);
        let selected = state.structure.getIn(['selected', 'event']);
        if(typeof selected === 'undefined' || selected === null)return null;
        if(typeof selectedTournament === 'undefined' || selectedTournament === null)return null;

        if(!state.structure.hasIn(['events', selectedTournament]))return null;
        let events = Object.values(state.structure.getIn(['events', selectedTournament]).toJS());
        
        for(var event of events)
            if(event['uid'] === selected)return event;
        return null;
    })*/

    /*if(event === null)return null;

    return (
        <div style={{
            margin: '20px',
            width: '100%'
        }}>
            <h1>{event.name}</h1>

            <Menu pointing secondary>
                <Menu.Item active={activeItem === 0} onClick={() => setActiveItem(0)}>
                    Allgemein
                </Menu.Item>
                <Menu.Item active={activeItem === 1} onClick={() => setActiveItem(1)}>
                    Märkte
                </Menu.Item>
                <Menu.Item active={activeItem === 2} onClick={() => setActiveItem(2)}>
                    Tabelle
                </Menu.Item>
                <Menu.Item active={activeItem === 3} onClick={() => setActiveItem(3)}>
                    Prematch
                </Menu.Item>
                <Menu.Item active={activeItem === 4} onClick={() => setActiveItem(4)}>
                    Live
                </Menu.Item>
            </Menu>

            {
                (activeItem === 0)?
                <EventProperties event={event} />
                :null
            }
            {
                (activeItem === 2)?
                    <Sportradar.Leaguetable id={event['betradar-id']} />
                :null
            }
            {
                (activeItem === 3)?
                    <Sportradar.Prematch id={event['betradar-id']} />
                :null
            }
            {
                (activeItem === 4)?
                    <Sportradar.Live id={event['betradar-id']} />
                :null
            }
        </div>
    )*/

}